import React from 'react';

/** The conversation controller supplies visibility after its one-second delay. */
export default function ChatTimelineLoading({ visible }: { visible: boolean }) {
  if (!visible) return null;

  return (
    <div className="chat-loading-overlay" role="status" aria-label="メッセージを読み込み中">
      <div className="chat-spinner chat-spinner--small" aria-hidden="true" />
    </div>
  );
}
